import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface TreeTableContainerProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

/**
 * Bordered, rounded container for a tree-table (header + body). Clips children
 * so the inner hover/border styles stay inside the rounded corners.
 */
export function TreeTableContainer({children, className, 'data-testid': testId}: TreeTableContainerProps) {
    return (
        <div className={cn('border rounded-lg overflow-hidden', className)} data-testid={testId}>
            {children}
        </div>
    )
}
